import axios from 'axios';

const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.REACT_APP_PARSE_USE_RELATIVE === 'true'
    ? '/api'
    : 'https://server.consult-it.com/api');

const instance = axios.create({
  baseURL,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance;
